export interface QuestionsIndicatorProps {
  count: number;
  onOpen: () => void;
}

export function QuestionsIndicator({ count, onOpen }: QuestionsIndicatorProps) {
  if (count === 0) return null;
  const label = `${count} ${count === 1 ? 'question' : 'questions'} waiting for your answer`;
  return (
    <button
      type="button"
      data-testid="questions-indicator"
      aria-label={label}
      title={label}
      onClick={onOpen}
      className="flex items-center gap-1 rounded-md bg-warning-subtle px-1.5 py-1 text-warning-text hover:bg-warning-subtle/80"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <path d="M12 17h.01" />
      </svg>
      <span data-testid="questions-indicator-count" className="text-micro">
        {count}
      </span>
    </button>
  );
}
